import { useEffect, useState } from "react";
import { Modal, FormField, Notification } from "@weirgroup/weir-dls";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import { useDarkMode } from "../../hooks/use-darkmode";
import { useAnalyticsEvent } from "../../hooks/useAnalyticsEvent";

interface Props {
    toggleDialog?: () => void;
    open?: boolean;
    externalFleetApi: string
}

export const ExternalFleetApiModal = (props: Props) => {
    const logAnalyticsEvent = useAnalyticsEvent();
    const { open, toggleDialog, externalFleetApi } = props;
    const { t } = useTranslation();
    const [showToast, setShowToast] = useState<boolean>(false)
    const [toastData, setToastData] = useState<any>()
    const {darkMode} = useDarkMode()
    useEffect(() => {
        if (showToast) {
            setTimeout(() => setShowToast(false), 3000)
        }
    }, [showToast])

    const handleCopy = () => {
        navigator.clipboard.writeText(externalFleetApi).then(() => {
            setToastData({
                variant: "success",
                message: t("copiedToClipboard")
            })
            setShowToast(true)
            logAnalyticsEvent('web_user_copy_external_fleet_api_token', { description: 'User copied external fleet API token to clipboard' });
        })
    }
    return (
        <>
            <Modal
                darkMode={darkMode}
                showModal={open}
                onClose={toggleDialog}
                size="small"
                dismissable
            >
                <p className="title" style={{color:darkMode ? "white":"black"}}>{t("fleetApiToken")}</p>
               
                <div className="external-fleet-container full-form-field">
                     <FormField
                            darkMode={darkMode}
                            icon={"CopyOutlined"}
                            name="ExternalFleetAPI"
                            onIconClick={() => handleCopy()}
                            type="text"
                            optionalText=""
                            value={externalFleetApi}
                            applyModalInternalGrid
                            modalType="small"
                        />
                </div>
            </Modal>
            {showToast ? <div className="toast-container">
                <Notification
                    darkMode={darkMode}
                    title={toastData.variant == "success" ? "Success" : "Fail"}
                    textContent={toastData.message}
                    variant={toastData.variant}
                    onClose={()=>{setShowToast(false)}}
                />
            </div> : <></>}
        </>
    )
}